"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _StepperNavigation_stepperLocation_accessor_storage, _StepperNavigation_steps_accessor_storage, _StepperNavigation_activeStepIndex_accessor_storage, _StepperNavigation_containerClass_accessor_storage, _StepperNavigation_linearProgression_accessor_storage, _StepperNavigation_toolbarButtons_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperNavigation = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const stepper_navigation_styles_1 = require("./stepper-navigation-styles");
const stepper_navigation_location_enum_1 = require("./stepper-navigation-location.enum");
let StepperNavigation = class StepperNavigation extends lit_1.LitElement {
    get stepperLocation() { return __classPrivateFieldGet(this, _StepperNavigation_stepperLocation_accessor_storage, "f"); }
    set stepperLocation(value) { __classPrivateFieldSet(this, _StepperNavigation_stepperLocation_accessor_storage, value, "f"); }
    get steps() { return __classPrivateFieldGet(this, _StepperNavigation_steps_accessor_storage, "f"); }
    set steps(value) { __classPrivateFieldSet(this, _StepperNavigation_steps_accessor_storage, value, "f"); }
    get activeStepIndex() { return __classPrivateFieldGet(this, _StepperNavigation_activeStepIndex_accessor_storage, "f"); }
    set activeStepIndex(value) { __classPrivateFieldSet(this, _StepperNavigation_activeStepIndex_accessor_storage, value, "f"); }
    get containerClass() { return __classPrivateFieldGet(this, _StepperNavigation_containerClass_accessor_storage, "f"); }
    set containerClass(value) { __classPrivateFieldSet(this, _StepperNavigation_containerClass_accessor_storage, value, "f"); }
    get linearProgression() { return __classPrivateFieldGet(this, _StepperNavigation_linearProgression_accessor_storage, "f"); }
    set linearProgression(value) { __classPrivateFieldSet(this, _StepperNavigation_linearProgression_accessor_storage, value, "f"); }
    get toolbarButtons() { return __classPrivateFieldGet(this, _StepperNavigation_toolbarButtons_accessor_storage, "f"); }
    set toolbarButtons(value) { __classPrivateFieldSet(this, _StepperNavigation_toolbarButtons_accessor_storage, value, "f"); }
    constructor() {
        super();
        _StepperNavigation_stepperLocation_accessor_storage.set(this, stepper_navigation_location_enum_1.StepperNavigationLocationEnum.LEFT);
        _StepperNavigation_steps_accessor_storage.set(this, []);
        _StepperNavigation_activeStepIndex_accessor_storage.set(this, 0);
        _StepperNavigation_containerClass_accessor_storage.set(this, '');
        _StepperNavigation_linearProgression_accessor_storage.set(this, false);
        _StepperNavigation_toolbarButtons_accessor_storage.set(this, []);
        Object.defineProperty(this, "stepEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
    }
    createRenderRoot() {
        return this;
    }
    async checkValidation(step) {
        if (step.beforeStepValidation) {
            if (!(await step.beforeStepValidation())) {
                return false;
            }
        }
        return true;
    }
    async onStepSelect(event) {
        const step = this.steps[this.activeStepIndex];
        if (await this.checkValidation(step)) {
            this.activeStepIndex = event.detail;
            this.requestUpdate();
        }
    }
    async handleNextButtonClick() {
        const stepsTotal = this.steps.length;
        const nextStep = this.activeStepIndex + 1;
        if (nextStep < stepsTotal) {
            if (await this.checkValidation(this.steps[nextStep])) {
                this.activeStepIndex = nextStep;
                this.requestUpdate();
            }
        }
        else {
            this.activeStepIndex = stepsTotal - 1;
        }
        this.requestUpdate();
    }
    handlePreviousButtonClick() {
        const previousStep = this.activeStepIndex - 1;
        if (previousStep >= 0) {
            this.activeStepIndex = previousStep;
        }
        else {
            this.activeStepIndex = 0;
        }
        this.requestUpdate();
    }
    handleSubmitButtonClick() {
        const options = {
            bubbles: true,
            composed: true,
        };
        this.dispatchEvent(new CustomEvent('stepperSubmitClicked', options));
        this.requestUpdate();
    }
    getScaffoldSlotFromStepperLocation() {
        switch (this.stepperLocation) {
            case stepper_navigation_location_enum_1.StepperNavigationLocationEnum.TOP:
                return 'body-header';
            case stepper_navigation_location_enum_1.StepperNavigationLocationEnum.RIGHT:
                return 'body-right';
            case stepper_navigation_location_enum_1.StepperNavigationLocationEnum.BOTTOM:
                return 'body-footer';
            case stepper_navigation_location_enum_1.StepperNavigationLocationEnum.LEFT:
            default:
                return 'body-left';
        }
    }
    renderStepComponents() {
        return (0, lit_1.html) `
      ${this.steps.map(({ component, label }) => (0, lit_1.html) `
          <forge-view name=${label}> ${component} </forge-view>
        `)}
    `;
    }
    render() {
        this.stepEnd = this.steps.length - 1;
        return (0, lit_1.html) `
      <forge-scaffold class=${this.containerClass}>
        <sup-component-stepper
          @onStepSelect=${this.onStepSelect}
          slot=${this.getScaffoldSlotFromStepperLocation()}
          .linearProgression=${this.linearProgression}
          .steps=${this.steps}
          .selectedIndex=${this.activeStepIndex}
          .vertical=${this.stepperLocation === stepper_navigation_location_enum_1.StepperNavigationLocationEnum.LEFT ||
            this.stepperLocation === stepper_navigation_location_enum_1.StepperNavigationLocationEnum.RIGHT}
          .direction=${this.stepperLocation}
        >
        </sup-component-stepper>
        <forge-view-switcher slot="body" index=${this.activeStepIndex}>
          ${this.renderStepComponents()}
        </forge-view-switcher>
        <div slot="footer">
          <forge-toolbar inverted>
            ${this.toolbarButtons.map((button) => (0, lit_1.html) `
                <forge-button
                  class=${button.className}
                  slot=${button.slot}
                  theme=${button.theme}
                  variant=${button.variant}
                  @click=${button.function}
                >
                  ${button.iconPlacement === 'right'
            ? (0, lit_1.html) `
                        <forge-icon name=${button.icon}></forge-icon>
                        ${button.label}
                      `
            : (0, lit_1.html) `${button.label} <forge-icon name=${button.icon}></forge-icon>`}
                </forge-button>
              `)}
            <forge-button slot="end" slot="end" variant="outlined" @click=${this.handlePreviousButtonClick}>
              <forge-icon name="arrow_left"></forge-icon>
              ${this.steps[this.activeStepIndex].previousButtonLabel ?? 'Previous'}
            </forge-button>
            <forge-button
              slot="after-end"
              variant="raised"
              type=${this.activeStepIndex === this.stepEnd ? 'submit' : 'button'}
              @click=${this.activeStepIndex === this.stepEnd
            ? this.handleSubmitButtonClick
            : this.handleNextButtonClick}
              style="margin-right: 10px;"
            >
              ${this.activeStepIndex === this.stepEnd
            ? 'Submit'
            : this.steps[this.activeStepIndex].nextButtonLabel ?? 'Next'}
              ${this.activeStepIndex === this.stepEnd ? (0, lit_1.html) `` : (0, lit_1.html) `<forge-icon name="arrow_right"></forge-icon>`}
            </forge-button>
          </forge-toolbar>
        </div>
      </forge-scaffold>
    `;
    }
};
exports.StepperNavigation = StepperNavigation;
_StepperNavigation_stepperLocation_accessor_storage = new WeakMap();
_StepperNavigation_steps_accessor_storage = new WeakMap();
_StepperNavigation_activeStepIndex_accessor_storage = new WeakMap();
_StepperNavigation_containerClass_accessor_storage = new WeakMap();
_StepperNavigation_linearProgression_accessor_storage = new WeakMap();
_StepperNavigation_toolbarButtons_accessor_storage = new WeakMap();
Object.defineProperty(StepperNavigation, "styles", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [stepper_navigation_styles_1.stepperNavigationStyles]
});
__decorate([
    (0, decorators_js_1.property)({ type: String })
], StepperNavigation.prototype, "stepperLocation", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], StepperNavigation.prototype, "steps", null);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], StepperNavigation.prototype, "activeStepIndex", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], StepperNavigation.prototype, "containerClass", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], StepperNavigation.prototype, "linearProgression", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], StepperNavigation.prototype, "toolbarButtons", null);
exports.StepperNavigation = StepperNavigation = __decorate([
    (0, decorators_js_1.customElement)('sup-stepper-navigation')
], StepperNavigation);
